var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 19C2.92893 19 1.25 17.3211 1.25 15.25C1.25 13.4544 2.40962 12.2009 3.93287 11.7191C4.60406 11.5068 5.10395 10.7817 5.03038 10.0815C5.0103 9.89044 5 9.69642 5 9.5C5 6.46243 7.46243 4 10.5 4C12.7582 4 14.6985 5.36088 15.5455 7.30724C15.8344 7.97101 16.435 8.5 17.1589 8.5H17.5C20.3995 8.5 22.75 10.8505 22.75 13.75C22.75 16.6495 20.3995 19 17.5 19H5Z",
    stroke: "#037BC0",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.8ba6399d674f4be9f8ca33190cb780af.svg";
export { ForwardRef as ReactComponent };